import React from 'react';
import styled from 'styled-components';
import { getColorBlock } from 'utils/ui/colors';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Wrapper = styled.div.withConfig({
  displayName: "StripesPattern__Wrapper",
  componentId: "sc-1ksbq28-0"
})(["height:0;color:", ";"], function (p) {
  return getColorBlock(p.stripesColor, p.theme);
});
function StripesPattern(_ref) {
  var id = _ref.id,
    color = _ref.color;
  return /*#__PURE__*/_jsx(Wrapper, {
    stripesColor: color,
    children: /*#__PURE__*/_jsx("svg", {
      width: "0",
      height: "0",
      viewBox: "0 0 20 20",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      children: /*#__PURE__*/_jsx("defs", {
        children: /*#__PURE__*/_jsx("pattern", {
          id: id,
          patternUnits: "userSpaceOnUse",
          width: "20",
          height: "20",
          children: /*#__PURE__*/_jsx("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/_jsxs("g", {
              fill: "currentColor",
              children: [/*#__PURE__*/_jsx("polygon", {
                points: "0 20 20 0 10 0 0 10"
              }), /*#__PURE__*/_jsx("polygon", {
                points: "20 20 20 10 10 20"
              })]
            })
          })
        })
      })
    })
  });
}
export default StripesPattern;